import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import {
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_MOBILE,
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_WEB_LARGE,
} from 'helpers/BreakpointHelper';
import { getNetworkBranding } from 'helpers/ContentHelper';
import style from './Error500.css';

const {
  maintenancePage_header: headerText,
  maintenancePage_message: messageText,
} = window.Language;

const Error500 = (props = {}) => {
  const { breakpoint, branding } = props;
  const maintenancePage = _.get(window, 'ExternalConfig.maintenancePage', {});
  const colors = _.get(maintenancePage, 'color', []);
  const imageDesktop = _.get(maintenancePage, 'background.desktop', null);
  const imageMobile = _.get(maintenancePage, 'background.mobile.portrait', null);
  const currentBranding = branding || getNetworkBranding();
  const wrapper = classNames([style.screen, style[currentBranding]]);

  const isFullBGImage = !!(colors.length === 0);

  const images = {
    [SITE_PLATFORM_WEB_LARGE]: imageDesktop,
    [SITE_PLATFORM_WEB]: imageDesktop,
    [SITE_PLATFORM_TABLET]: imageMobile,
    [SITE_PLATFORM_MOBILE]: imageMobile,
  };

  const renderCharacter = () => {
    const character = _.get(images, breakpoint, null);
    if (!character || isFullBGImage) return null;

    return (
      <div className={style.character}>
        <img src={character} alt="Background character" />
      </div>
    );
  };

  const renderColorBackground = () => {
    const gradientBG =
      colors.length === 2 ? `radial-gradient(circle at 50% 0, ${colors.join(', ')})` : null;
    const flatBG = colors.length === 1 ? colors[0] : null;
    if (!gradientBG && !flatBG) return null;

    const background = flatBG || gradientBG;
    return <div className={style.background} style={{ background }} />;
  };

  const renderImageBackground = () => {
    const image = _.get(images, breakpoint, null);
    const backgroundStyle = {
      backgroundImage: `url(${image})`,
    };

    return <div className={style.background} style={backgroundStyle} />;
  };

  return (
    <div className={wrapper}>
      <div className={style.backgroundOverlay} />
      {isFullBGImage ? renderImageBackground() : renderColorBackground()}
      <div className={style.info}>
        {renderCharacter()}
        <div className={style.header}>{headerText}</div>
        <div className={style.message}>{messageText}</div>
      </div>
    </div>
  );
};

Error500.defaultProps = {
  breakpoint: SITE_PLATFORM_WEB,
  branding: null,
};

Error500.propTypes = {
  breakpoint: PropTypes.string,
  branding: PropTypes.string,
};

export default Error500;
